<template>
	<div class="lb">
		<div ref="barMian" class="barMian" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope3',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			timer: null,
			defaultdata: [
				{ value1: '福建', value2: '8', value3: "系列一", value4: '%' },
				{ value1: '上海', value2: '7.7' },
				{ value1: '北京', value2: '7' },
				{ value1: '山东', value2: '6.8' },
				{ value1: '河北', value2: '6' },
				{ value1: '安徽', value2: '5.8' },
				{ value1: '四川', value2: '5.6' },
				{ value1: '陕西', value2: '5' },
				{ value1: '湖南', value2: '4.8' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
				{ name: '图例', key: 'value3' },
				{ name: '单位', key: 'value4' },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
					let vlist = Object.keys(item)
					let isdata = false
					vlist.forEach(del => {
						if (item[del] == undefined) {
							item[del] = ''
						} else if (del && item[del]) {
							isdata = true
						}
					})
					if (vlist.length && isdata) return item
				})
				this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.TdrawLine()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		...methods,
		TdrawLine() {
			clearInterval(this.timer)
			this.timer = null
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.barMian);
			let myData = []
			let numA = []
			this.defaultdata.forEach((item) => {
				myData.push(item[this.valueMap[0].key])
				numA.push(item[this.valueMap[1].key])
			})
			const xAxis = this.defaultdata.map(item => {
				return item.value1
			})
			let unit = this.defaultdata[0].value4 || ''
			const percent = 7 / xAxis.length * 100
			let zoom = [
				{
					id: 'scope3', // 唯一的id
					filterMode: 'empty',
					xAxisIndex: [0],//滑动条为竖
					mayValueSpan: 7, // 显示数据的条数(默认显示10个)
					type: 'slider',
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
					dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					moveHandleSize: 0,
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					backgroundColor: "transparent",
					fillerColor: "rgba(0,0,0,.2)",
					borderColor: "transparent",
					start: 0,
					end: percent,
				},
			];
			var Toption = {
				title: [{
					text: unit,
					top: '0',
					left: "0",
					textStyle: {
						color: "#979AA0",
						fontSize: 12,
					},
				}],
				tooltip: {
					trigger: 'axis'
				},
				legend: [
					{
						top: "2%",
						right: 50,
						itemHeight: 12, //图例的高度  文字左边那个
						itemWidth: 10,
						icon: 'rect',
						textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
						data: [this.defaultdata[0].value3 || '']
					},
				],
				grid: {
					left: '5px',
					right: '10px',
					bottom: '0px',
					top: '40px',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: true,
					data: xAxis,
					axisLabel: {
						interval: 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						overflow: 'truncate', //文字超出宽度截断 换行
						textStyle: {
							color: '#bdc2cb', // 这里将 x 轴文本颜色设为红色
							fontSize: '14',
							lineHeight: 16,
						},
					},
					axisLine: {
						lineStyle: { // X 轴颜色配置
							color: '#4792e9'
						}
					},
					axisTick: {
						show: false
					},
				},
				yAxis: {
					type: 'value',
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: '#bdc2cb' // 这里将 x 轴文本颜色设为红色
						}
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: "rgba(231,241,251,.2)"
						}
					}
				},
				series: [
					{
						name: this.defaultdata[0].value3 || '',
						type: 'bar',
						smooth: true,
						stack: 'Total',
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#0b1f42" // 0% 处的颜色
								}, {
									offset: 0.5,
									color: "#0a4ba6" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#0a72fc" // 100% 处的颜色
								}], false)
							}
						},
						symbolSize: 0,
						label: {
							show: true,
							position: 'top',
							textStyle: {
								//设置文本样式
								color: "#CBD8DE",
							}
						},
						markPoint: {
							data: numA.map((value, index) => ({
								coord: [myData[index], value],
								symbol: 'rect',
								symbolSize: [14, 2],
								itemStyle: {
									color: '#0a72fc'
								}
							}))
						},
						data: numA,
						barWidth: 15,
						barGap: '40%',
					},
				],
				dataZoom: xAxis.length > 7 ? zoom : [],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.TdrawLine()
	},
}
</script>

<style scoped>
.lb {
	width: 435px;
	height: 240px;
	padding: 10px 0;
	display: flex;
	position: relative;
}

.barMian {
	width: 100%;
	height: 100%;
}
</style>